import React from "react";
import * as c from "./lpTwoColSection.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { processMarkdown } from "@utils/markdown";
import { ContentfulCta } from "@components/shared/cta";
import WistiaVideoPopover from "@components/wistia/wistiaVideoPopover";
import { IconPlayAlt } from "@components/icons/iconPlayAlt";

const Image = ({ desktopImage, mobileImage, alt = "" }) => (
  <>
    <GatsbyImage image={getImage(desktopImage)} className={c.desktopImage} alt={alt} />
    {mobileImage && <GatsbyImage image={getImage(mobileImage)} className={c.mobileImage} alt={`${alt} mobile`} />}
  </>
);

const WithConditonalWistiaPopover = ({ wistiaVideoId, children }) =>
  wistiaVideoId ? (
    <WistiaVideoPopover className={c.videoWrapper} wistiaVideoId={wistiaVideoId}>
      <IconPlayAlt className={c.playButton} />
      {children}
    </WistiaVideoPopover>
  ) : (
    children
  );

export default function LpTwoColSection({
  className,
  label,
  heading,
  subheading,
  shouldShowImageColumnFirst,
  wistiaVideoId = null,
  desktopImage,
  mobileImage,
  ctas = [],
  isFeaturePage,
}) {
  const subheadingHtml = processMarkdown(subheading?.subheading);

  // This is pretty ugly, but we need a way to remove the left-margin offset we add to links
  // of this type so that they will be correctly left/center aligned with the section
  const ctaHasDesktopOffset = (cta) =>
    cta?.__typename === "ContentfulCtaButton" && cta?.showIcon && cta?.style[0] === "Link";

  return (
    <section className={classNames(className, c.container, { [c.reverseOrder]: shouldShowImageColumnFirst })}>
      <div className={c.textContainer} data-transition="slide-enter-child">
        {label && <p className={classNames(c.label, "eyebrow")}>{label}</p>}
        <h2 className={classNames(c.heading, "h2", isFeaturePage && c.standardPageHeadline)}>{heading}</h2>
        <div
          className={classNames(c.subheading, isFeaturePage && c.standardPageSubheading, "p2")}
          dangerouslySetInnerHTML={{ __html: subheadingHtml }}
        />
        {ctas && ctas.length > 0 && (
          <div className={c.ctaContainer}>
            {ctas.map((cta) => (
              <ContentfulCta className={ctaHasDesktopOffset(cta) && c.ctaOffset} key={cta.id} {...cta} />
            ))}
          </div>
        )}
      </div>
      <div className={classNames(c.imageContainer, { [c.usesMobileImage]: mobileImage })} data-transition="slide-enter">
        <WithConditonalWistiaPopover wistiaVideoId={wistiaVideoId}>
          <Image desktopImage={desktopImage} mobileImage={mobileImage} alt={label || heading || ""} />
        </WithConditonalWistiaPopover>
      </div>
    </section>
  );
}
